var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4987 14.6667C12.1787 14.6667 15.1654 11.68 15.1654 8.00004C15.1654 4.32004 12.1787 1.33337 8.4987 1.33337C4.8187 1.33337 1.83203 4.32004 1.83203 8.00004",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidLoading);
export default __webpack_public_path__ + "static/media/bfid-loading.41139beb2cdf2cd4760fe73ce3fca843.svg";
export { ForwardRef as ReactComponent };